import { useSearchParams } from "react-router-dom";

/**
 * Draft/live channel for the Course Factory v2 serving plane. Mirrors the
 * server's Channel union (functions/_lib/course-content.ts — the source of
 * truth for how a request's channel resolves). Kept as a local copy rather
 * than imported: functions/ (Pages Functions runtime) and src/ (the
 * Vite-bundled SPA) are separate deploy targets, and functions/ code pulls in
 * server-only bindings (KV, R2, Env) that have no place in the client bundle.
 */
export type Channel = "draft" | "live";

/**
 * Reads `channel` off the current route's search params. Anything other than
 * exactly "draft" (absent, empty, or any other value) resolves to "live" —
 * mirrors channelFromRequest on the server.
 */
export function useChannel(): Channel {
  const [searchParams] = useSearchParams();
  return searchParams.get("channel") === "draft" ? "draft" : "live";
}

/**
 * Appends `channel=draft` to `path` when channel is "draft"; returns `path`
 * unchanged for "live" so live URLs stay clean.
 */
export function withChannel(path: string, channel: Channel): string {
  if (channel !== "draft") return path;
  return path.includes("?") ? `${path}&channel=draft` : `${path}?channel=draft`;
}
